import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FileText } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen bg-offwhite font-sans text-navy" data-id="element-794">
      <Navbar data-id="element-795" />
      <main className="pt-28 pb-20" data-id="element-796">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-797">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-798">
            <div className="w-14 h-14 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-799">
              <FileText className="w-7 h-7 text-navy" data-id="element-800" />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-2" data-id="element-801">
              Terms & Conditions
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-802">
              Effective Date: 24 February 2026
            </p>
            <p className="text-gold-dark font-semibold italic mt-1 text-sm" data-id="element-803">
              A Dream Smile is a Reality
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10" data-id="element-804">
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-805">
              These Terms & Conditions govern your use of the De Rien Cash Loan
              website, submission of loan applications (online or physical), and
              any financial services provided by De Rien Cash Loan (Pty) Ltd. By
              accessing our website or submitting an application, you agree to
              these Terms.
            </p>

            <Section title="1. Introduction" data-id="element-806">
              <p data-id="element-807">These Terms & Conditions govern:</p>
              <ul data-id="element-808">
                <li data-id="element-809">Your use of the De Rien Cash Loan website</li>
                <li data-id="element-810">Submission of loan applications (online or physical)</li>
                <li data-id="element-811">
                  Any financial services provided by De Rien Cash Loan (Pty) Ltd
                </li>
              </ul>
              <p className="mt-3" data-id="element-812">
                By accessing our website or submitting an application, you agree
                to these Terms.
              </p>
            </Section>

            <Section title="2. Loan Application" data-id="element-813">
              <p data-id="element-814">Submitting a loan application:</p>
              <ul data-id="element-815">
                <li data-id="element-816">Does not guarantee approval</li>
                <li data-id="element-817">Constitutes an offer to contract with De Rien Cash Loan</li>
                <li data-id="element-818">Is subject to credit assessment and verification</li>
              </ul>
              <p className="mt-3" data-id="element-819">
                We reserve the right to approve or reject any application at our
                sole discretion.
              </p>
              <p className="mt-3" data-id="element-820">
                Applicants must provide accurate and complete information. False
                or misleading information may result in immediate rejection or
                cancellation.
              </p>
            </Section>

            <Section title="3. Eligibility" data-id="element-821">
              <p data-id="element-822">To qualify for a loan, you must:</p>
              <ul data-id="element-823">
                <li data-id="element-824">Be 18 years or older</li>
                <li data-id="element-825">
                  Not be under administration or debt restructuring (unless
                  disclosed)
                </li>
                <li data-id="element-826">Provide required documentation</li>
                <li data-id="element-827">Pass affordability and credit checks</li>
              </ul>
              <p className="mt-3" data-id="element-828">
                We may request additional information at any stage.
              </p>
            </Section>

            <Section title="4. Loan Approval & Agreement" data-id="element-829">
              <p data-id="element-830">
                If your application is approved, you will receive a loan
                agreement outlining:
              </p>
              <ul data-id="element-831">
                <li data-id="element-832">Loan amount</li>
                <li data-id="element-833">Interest rate</li>
                <li data-id="element-834">Repayment period</li>
                <li data-id="element-835">Instalment amount</li>
                <li data-id="element-836">Administrative fees</li>
              </ul>
              <p className="mt-3" data-id="element-837">
                The agreement becomes legally binding once signed (physically or
                electronically).
              </p>
            </Section>

            <Section title="5. Interest & Fees" data-id="element-838">
              <p data-id="element-839">Loan agreements may include:</p>
              <ul data-id="element-840">
                <li data-id="element-841">Fixed interest rates</li>
                <li data-id="element-842">Administrative fees</li>
                <li data-id="element-843">Processing fees (if applicable)</li>
              </ul>
              <p className="mt-3" data-id="element-844">
                All charges will be clearly disclosed before final acceptance.
              </p>
              <p className="mt-2 font-medium text-navy" data-id="element-845">
                De Rien Cash Loan does not apply hidden charges.
              </p>
            </Section>

            <Section title="6. Repayment Terms" data-id="element-846">
              <p data-id="element-847">Repayment shall:</p>
              <ul data-id="element-848">
                <li data-id="element-849">
                  Be made via approved deduction method (e.g., stop order,
                  source pay, online banking)
                </li>
                <li data-id="element-850">Be deducted monthly as agreed</li>
                <li data-id="element-851">Be paid in full on due dates</li>
              </ul>
              <p className="mt-3" data-id="element-852">
                Failure to pay on the due date will result in:
              </p>
              <ul data-id="element-853">
                <li data-id="element-854">
                  A <strong data-id="element-855">5% penalty</strong> on late payments
                </li>
                <li data-id="element-856">Possible legal recovery action</li>
              </ul>
            </Section>

            <Section title="7. Cooling-Off Period" data-id="element-857">
              <p data-id="element-858">
                Borrowers have the right to cancel the loan within{' '}
                <strong data-id="element-859">2 days</strong> of signing the agreement or
                disbursement.
              </p>
              <p className="mt-3" data-id="element-860">The borrower must:</p>
              <ul data-id="element-861">
                <li data-id="element-862">Repay the full amount disbursed</li>
                <li data-id="element-863">Pay prorated cost of credit (P50.00)</li>
              </ul>
              <p className="mt-3" data-id="element-864">No termination fee will be charged.</p>
            </Section>

            <Section title="8. Default & Legal Action" data-id="element-865">
              <p data-id="element-866">If you default on payment:</p>
              <ul data-id="element-867">
                <li data-id="element-868">We may initiate legal recovery proceedings</li>
                <li data-id="element-869">
                  Collection costs and legal expenses may be recovered from you
                </li>
                <li data-id="element-870">Your credit record may be affected</li>
              </ul>
            </Section>

            <Section title="9. Early Settlement" data-id="element-871">
              <p data-id="element-872">
                Borrowers may settle the loan early. Terms of early settlement
                will be outlined in the signed agreement.
              </p>
            </Section>

            <Section title="10. Use of Website" data-id="element-873">
              <p data-id="element-874">You agree not to:</p>
              <ul data-id="element-875">
                <li data-id="element-876">Submit fraudulent applications</li>
                <li data-id="element-877">Misuse or attempt to hack the website</li>
                <li data-id="element-878">Upload malicious content</li>
              </ul>
              <p className="mt-3" data-id="element-879">
                We reserve the right to restrict or terminate access for misuse.
              </p>
            </Section>

            <Section title="11. Data Protection" data-id="element-880">
              <p data-id="element-881">
                All personal information submitted will be handled according to
                our{' '}
                <a href="#privacy" className="text-navy underline" data-id="element-882">
                  Privacy Policy
                </a>
                .
              </p>
              <p className="mt-3" data-id="element-883">
                By applying, you authorize De Rien Cash Loan to:
              </p>
              <ul data-id="element-884">
                <li data-id="element-885">Verify your identity</li>
                <li data-id="element-886">Conduct credit checks</li>
                <li data-id="element-887">
                  Share relevant information with credit bureaus and regulators
                </li>
              </ul>
            </Section>

            <Section title="12. Limitation of Liability" data-id="element-888">
              <p data-id="element-889">De Rien Cash Loan shall not be liable for:</p>
              <ul data-id="element-890">
                <li data-id="element-891">Indirect or consequential damages</li>
                <li data-id="element-892">Delays caused by third-party service providers</li>
                <li data-id="element-893">Website downtime or technical interruptions</li>
              </ul>
            </Section>

            <Section title="13. Amendments" data-id="element-894">
              <p data-id="element-895">
                We reserve the right to update these Terms & Conditions at any
                time. Updated versions will be posted on this page with a
                revised effective date.
              </p>
            </Section>

            <Section title="14. Governing Law" data-id="element-896">
              <p data-id="element-897">
                These Terms & Conditions are governed by the laws of the
                Republic of Botswana.
              </p>
              <p className="mt-2" data-id="element-898">
                Any disputes shall be resolved in the competent courts of
                Botswana.
              </p>
            </Section>

            <Section title="15. Contact Information" data-id="element-899">
              <div className="mt-2 bg-offwhite rounded-xl p-6 text-sm text-gray-700 space-y-1 border border-gray-100" data-id="element-900">
                <p className="font-bold text-navy" data-id="element-901">
                  De Rien Cash Loan (Pty) Ltd
                </p>
                <p data-id="element-902">Plot 20582, Block 3, Unit 9/10</p>
                <p data-id="element-903">P.O Box 3568, Gaborone</p>
                <p data-id="element-904">
                  Email:{' '}
                  <a href="mailto:derien@derien.co.bw" className="text-navy underline" data-id="element-905">
                    derien@derien.co.bw
                  </a>
                </p>
                <p data-id="element-906">
                  Tel:{' '}
                  <a href="tel:+26774833041" className="text-navy underline" data-id="element-907">
                    +267 74 833 041
                  </a>{' '}
                  /{' '}
                  <a href="tel:+26777685555" className="text-navy underline" data-id="element-908">
                    +267 77 685 555
                  </a>
                </p>
              </div>
            </Section>
          </div>

          <div className="text-center mt-8" data-id="element-909">
            <a href="#" className="text-sm text-gray-500 hover:text-navy transition-colors" data-id="element-910">
              ← Back to Home
            </a>
          </div>
        </div>
      </main>
      <Footer data-id="element-911" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-912">
      <h2 className="text-xl font-heading font-bold text-navy mb-4 pb-2 border-b border-gray-100" data-id="element-913">
        {title}
      </h2>
      <div className="text-gray-600 leading-relaxed space-y-3 text-sm [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-1 [&_ul]:ml-2" data-id="element-914">
        {children}
      </div>
    </div>;
}